export default __webpack_public_path__ + "static/smbGauge-e5e021dfa1ca9404ed10252737d635ab.png";